import { Pagination } from './../core/models/pagination';
import { NgModule, APP_INITIALIZER } from "@angular/core";
import { DialogModalComponent } from "./components/dialog-modal/dialog-modal.component";
import { FormInputCalendarComponent } from "./components/form-input-calendar/form-input-calendar.component";
import { ShellComponent } from "./components/shell/shell.component";
import { ToastsComponent } from "./components/toasts/toasts.component";
import { EvencharacterValidatorDirective } from "./directives/validators/evencharacter-validator.directive";
import { HexValidatorDirective } from "./directives/validators/hex-validator.directive";
import { SameStringValidatorDirective } from "./directives/validators/same-string-validator.directive";
import { RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { EnumToArrayPipe } from "./pipes/enum-to-array-pipe";
import { BlockchainSignModalComponent } from "./components/blockchain-sign-modal/blockchain-sign-modal.component";
import { AppPasswordDirective } from "./directives/app-password.directive";
import { LoaderComponent } from "./components/loader/loader.component";
import { InputRestrictionDirective } from "./directives/input-restriction.directive";
import { NotificationComponent } from "./components/notification/notification.component";
import { NgxPaginationModule } from "ngx-pagination";
import { BackButtonComponent } from "./components/back-button/back-button.component";
import { BackButtonService } from "./services/back-url.service";
import { AuthService } from "../core/services/api/auth.service";
import { InputDataListComponent } from "./components/input-data-list/input-data-list.component";
import { InputDataOptionComponent } from "./components/input-data-list/input-data-option/input-data-option.component";
import { CurrencyFormatPipe } from "./pipes/replace.pipe";
import { DateTimePipe } from "./pipes/dateTime.pipe";
import { TranslateModule } from "@ngx-translate/core";
import { ButtonComponent } from "./components/button/button.component";
import { HeaderComponent } from "./components/header/header.component";
import { IdiomComponent } from "./components/idiom/idiom.component";
import { TruncatePipe } from "./pipes/truncate.pipe";
import { PaginationComponent } from "./components/pagination/pagination.component";

export const options: Partial<null> | (() => Partial<null>) = null;

@NgModule({
  imports: [
    CommonModule,
    NgbModule,
    FormsModule,
    RouterModule,
    NgxPaginationModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
  exports: [
    //COMPONENTS
    BackButtonComponent,
    LoaderComponent,
    DialogModalComponent,
    FormInputCalendarComponent,
    ShellComponent,
    ToastsComponent,
    InputDataListComponent,
    InputDataOptionComponent,
    //DIRECTIVES
    EvencharacterValidatorDirective,
    HexValidatorDirective,
    SameStringValidatorDirective,
    EnumToArrayPipe,
    AppPasswordDirective,
    InputRestrictionDirective,
    NotificationComponent,
    CurrencyFormatPipe,
    DateTimePipe,
    TranslateModule,
    TruncatePipe,
    ButtonComponent,
    HeaderComponent,    
    PaginationComponent,
  ],
  declarations: [
    //COMPONENTS
    BackButtonComponent,
    LoaderComponent,
    DialogModalComponent,
    FormInputCalendarComponent,
    ShellComponent,
    ToastsComponent,
    InputDataListComponent,
    InputDataOptionComponent,

    //DIRECTIVES
    EvencharacterValidatorDirective,
    HexValidatorDirective,
    SameStringValidatorDirective,
    EnumToArrayPipe,
    BlockchainSignModalComponent,
    AppPasswordDirective,
    InputRestrictionDirective,
    NotificationComponent,
    CurrencyFormatPipe,
    DateTimePipe,
    ButtonComponent,
    HeaderComponent,
    PaginationComponent,
    IdiomComponent,
    TruncatePipe,
  ],
  entryComponents: [DialogModalComponent],
  providers: [
    AuthService,
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [BackButtonService],
      useFactory: (BackButtonService) => () => null,
    },
  ],
})
export class SharedModule { }
